module.exports = __webpack_public_path__ + "static/media/msg.d093903.mp3";